var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{staticClass:"page-terms"},[_c('v-container',[_c('v-row',{staticClass:"justify-content-center"},[_c('v-col',{attrs:{"md":9}},[_c('v-logo'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.privacy_template.template)}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016f35e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/pages/privacy.vue
// module id = null
// module chunks = 